import React, { useState } from 'react'
import "./common.scss"
import { AddIcon } from '../../../../utils/icons';
import CommonModal from "../../../../Components/Modals/index";
import Dropdown from '../../../../Components/Dropdown';
import InputError from '../../../../Components/InputError';
import { TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CommonField = ({ rows,
  inputData = {}, setInputData, handleInputChange = () => { }, isDisable = false }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [dateValue, setDateValue] = useState("");

  console.log("ROWS", rows)

  const handleDateChange = (newDate, itm) => {
    if (newDate) {
      const formattedDate = dayjs(newDate).format("MM-DD-YYYY"); // Convert to MM-DD-YYYY
      // setDate(newDate); // Keep original Date object
      handleInputChange({ target: { name: itm.name, value: formattedDate } }, itm.type, itm);
    }
  };


  // const handleInputChange = (e,id) => {
  //   console.log(e,id,"IDD")
  //   const { name, value } = e.target;
  //   if(id === 1){
  //     setInputData({ 
  //       ...inputData,
  //       companyInformation:{...inputData.companyInformation,[name]: value}
  //        })
  //   }
  //   if(id===2){
  //     setInputData({ 
  //       ...inputData,
  //       mbeInformation:{...inputData.mbeInformation,[name]: value}
  //        })
  //   }
  //   // setInputData((prev) => ({
  //   //   ...prev,
  //   //   [name]: value,
  //   // }));

  // };

  const getValue = (name, id) => {
    switch (id) {
      case 1:
        return inputData.companyInformation[name] || "";
      case 2:
        return inputData.mbeInformation[name] || "";
      case 3:
        return inputData.diverseInformation[name] || "";
      case 4:
        return inputData.subcontractInformation[name] || "";
      case 5:
        return inputData.revenueInformation[name] || "";
      case 6:
        return inputData.workforceInformation[name] || "";
      // Add cases for other IDs as needed
      default:
        return "";
    }
  };


  console.log("SETINP", inputData)
  const renderField = (itm) => {
     console.log("KLKL",itm)
    switch (itm.fieldType) {
      case "alphabet":
        return (
          <div>
            <input
              type="text"
              className='inpClass'
              placeholder={itm.place}
              style={{ border: itm.validation ? "1px solid red" : "" }}
              name={itm.name}
              disabled={isDisable || itm.name === "company_name"}
              value={getValue(itm.name, itm.type)}
              onChange={(e) => handleInputChange(e, itm.type, itm)} // Use input handler
            />
            {itm.validation ? <InputError text={itm.validation} /> : <div></div>}
          </div>
        );
      case "numeric":
        return (
          <div>
            <input
              type="number"
              className='inpClass'
              placeholder={itm.place}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              name={itm.name}
              disabled={isDisable}
              style={{ border: itm.validation ? "1px solid red" : "" }}
              value={getValue(itm.name, itm.type)}
              // value={inputData[itm.name] || ''}
              onChange={(e) => handleInputChange(e, itm.type, itm)} // Use input handler  
            />
            {itm.validation ? <InputError text={itm.validation} /> : <div></div>}
          </div>
        );
      case "date":
        return (

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              // value={getValue(itm.name, itm.type)}
              onChange={(e) => handleDateChange(e, itm)}
              format="MM-DD-YYYY" // Display format
              renderInput={(params) => (
                <TextField
                  {...params}
                  id="date-picker"
                  name={itm.name}
                  disabled={isDisable}
                  inputProps={{
                    style: {
                      height: '30px', // Adjust height directly
                      fontSize: '14px', // Adjust font size
                      padding: '6px 10px', // Adjust padding inside the input
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        );
      case "dropdown":
        return (
          <div>
            <Dropdown
              // label={"Field Type"}
              options={itm?.options}
              value={getValue(itm.name, itm.type)}
              name={itm.name}
              isDisabled={isDisable || itm.name === "category" || itm.name === "company_size" || itm.name === "type_of_utility"}
              // value={input}
              onChange={(e) => handleInputChange(e, itm.type, itm, true, itm.name)}
              placeholder={itm.place}
              isInput={true}
              isError={itm.validation}
              errorMessage={itm.validation}
            />
          </div>
        );
      case "boolean":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "4px 0" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "12px", color: "#ccc" }}>
              <input type="radio" id="yes" name={itm.name} value="yes" onChange={(e) => handleInputChange(e, itm.type, itm)} />
              Yes
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "12px", color: "#ccc" }}>
              <input type="radio" id="no" name={itm.name} value="no" onChange={(e) => handleInputChange(e, itm.type, itm)} />
              No
            </label>
          </div>
        );
      default:
        return null; // Or some fallback UI if needed
    }
  };


  return (
    <div className='inpCommFieldSection23'>
      <div className='contentForm'>
        {rows.map((itm, ind) => {
          return (
            itm.visible &&
            <div
              key={ind}
              className="contentSection"
            // onClick={() => handleAddClick(itm, ind)}
            >
              <div>{`${itm.label} ${itm.isRequired ? "*" : ""}`}</div>
              {renderField(itm)}
            </div>
          );
        }
        )}
      </div>

    </div>
  )
}

export default CommonField